import { useQuery } from '@tanstack/react-query';
import { fetchCustomer } from '@/lib/api';

export function useCustomer(shopifyCustomerId: string | number | undefined) {
  return useQuery({
    queryKey: ['customer', shopifyCustomerId],
    queryFn: () => fetchCustomer(shopifyCustomerId!),
    enabled: !!shopifyCustomerId,
    staleTime: 10_000,
  });
}
